import PropTypes from 'prop-types';
import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';

import LockIcon from '../icons/LockIcon';

import BillsLabelIcon from '../icons/BillsLabelIcon';

import DoubleArrowIcon from './DoubleArrowIcon';

import styles from './PaymentTimeline.module.scss';
import PaymentTimelineCard from './PaymentTimelineCard';
import OnBookingClosed from './OnBookingClosed';
import OnCheckIn from './OnCheckIn';

const noop = () => {};
const PaymentTimeline = ({
  listingCosts = {},
  pricing,
  downPaymentTimeInterval,
  hasNoDeposit,
  onSelectDates = noop,
  unCollapseAll = false
}) => {
  const currencyCode = pricing?.currencyCode || pricing?.currencyIsoCode;
  const completedMarkerClasses = classNames(
    styles['payment-timeline__marker'],
    styles['payment-timeline__marker--completed']
  );

  const progressLineClasses = classNames(
    styles['payment-timeline__progress-line'],
    styles['payment-timeline__progress-line--completed']
  );

  const isPricingCalculated = pricing?.totalContractValue > 0;

  return (
    <div className={styles['payment-timeline']}>
      <section className={styles['payment-timeline__section']}>
        <div className={completedMarkerClasses}>
          <DoubleArrowIcon />
        </div>
        <div className={progressLineClasses}>
          <span />
        </div>
        <div>
          <h3 className={styles['payment-timeline__section-title']}>
            {trans('payment.timeline.section1.title')}
          </h3>
          <OnBookingClosed
            isPricingCalculated={isPricingCalculated}
            currencyCode={currencyCode}
            pricing={pricing}
            costs={listingCosts?.onBookingClosed}
            downPaymentTimeInterval={downPaymentTimeInterval}
            onSelectDates={onSelectDates}
            collapsible={unCollapseAll}
            isCollapsed={!unCollapseAll}
          />
        </div>
      </section>
      <section className={styles['payment-timeline__section']}>
        <div className={styles['payment-timeline__marker']} />
        <div className={styles['payment-timeline__progress-line']} />
        <div>
          <h3 className={styles['payment-timeline__section-title']}>
            {trans('payment.timeline.section2.title')}
          </h3>

          <OnCheckIn
            isPricingCalculated={isPricingCalculated}
            costs={listingCosts?.onCheckIn}
            currencyCode={currencyCode}
            hasNoDeposit={hasNoDeposit}
            isCollapsed={!unCollapseAll}
          />
        </div>
      </section>
    </div>
  );
};

PaymentTimeline.propTypes = {
  pricing: PropTypes.shape({}).isRequired,
  listingCosts: PropTypes.shape({}),
  downPaymentTimeInterval: PropTypes.shape({
    type: PropTypes.oneOf(['months', 'weeks']),
    value: PropTypes.number
  }).isRequired,
  hasNoDeposit: PropTypes.bool.isRequired,
  onSelectDates: PropTypes.func,
  unCollapseAll: PropTypes.bool
};

export default PaymentTimeline;
